import { instance } from './api';

export const listRoles = () => instance.get(`/api/v1/users/roles`);

export const listPermissions = () => instance.get(`/api/v1/users/permissions`);

export const getRoleById = (id) => instance.get(`/api/v1/users/roles/${id}`);

export const editRoleById = (id, payload) => instance.put(`/api/v1/users/roles/${id}`, payload);

export const deleteRole = (id) => instance.delete(`/api/v1/users/roles/${id}`);

export const createRole = (payload) => instance.post(`/api/v1/users/roles`, payload);
